import { z } from "zod";

import { type ProductPaymentsPageQuery } from "src/queries/productSubscriptions";

export const PRODUCT_PAYMENTS_PAGE_SIZE = 10;
export const PRODUCT_SUBSCRIPTIONS_PAGE_SIZE = 10;

export const productPaymentsSearchSchema = z.object({
  p: z.number().optional(),
  ps: z.number().optional(),
  sp: z.number().optional(),
});

type ProductPaymentsSearch = z.infer<typeof productPaymentsSearchSchema>;

export function getProductPaymentsPageQuery(
  search: ProductPaymentsSearch,
): ProductPaymentsPageQuery {
  return {
    subscriptionsPageIndex: search.sp ?? 0,
    subscriptionsPageSize: PRODUCT_SUBSCRIPTIONS_PAGE_SIZE,
    paymentsPageIndex: search.p ?? 0,
    paymentsPageSize: search.ps ?? PRODUCT_PAYMENTS_PAGE_SIZE,
  };
}
